import { fonts } from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { ReactComponent as SvgClose } from '@img/icons/search-close.svg';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import LogoStyles from '@stories/Widgets/Headers/SiteHeader/components/Logo/Logo.styles';
import styled, { css } from 'styled-components';
const Container = styled.section `
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  height: 100vh;
  justify-content: center;
  text-align: center;
  width: 100%;
  /* Higher index than header container */
  z-index: 8002;

  ${({ active }) => active &&
    css `
      display: flex;
    `}

  ${LogoStyles.Container} {
    padding: 0 32px;
  }

  ${LogoStyles.Image} {
    display: inline-block;
    margin: 0 0 24px;

    @media ${from(Device.Tablet)} {
      margin: 0 0 48px;
    }
  }
`;
const Inner = styled.div `
  position: relative;
  display: block;
  background: #fff;
  border: 1px solid #b9b9b9;
  max-height: 100%;
  max-width: 665px;
  overflow-y: auto;
  padding: 24px 16px 24px;
  width: 100%;

  @media ${from(Device.Tablet)} {
    padding: 32px 108px 48px;
  }
`;
const CloseButton = styled.button.attrs({ type: 'button' }) `
  position: absolute;
  top: 24px;
  right: 16px;
  display: block;
  background: none;
  border: 0;
  color: #333333;
  height: 24px;
  margin: 0;
  padding: 0;
  width: 24px;

  &:focus,
  &:hover {
    background: none;
    border: 0;
    color: #333333;
  }

  > span {
    ${srOnly}
  }
`;
const CloseIcon = styled(SvgClose) ``;
const Form = styled.div `
  display: block;
  width: 100%;
`;
const Field = styled.div `
  display: block;
  margin: 0 0 16px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  @media ${from(Device.Tablet)} {
    margin: 0 0 28px;
  }

  > ${ButtonStyles.Button} {
    width: 100%;
  }

  &[data-flex='true'] {
    display: flex;
  }
`;
const Label = styled.label `
  display: block;
  ${fonts.DaxPro.Regular};
  font-size: 16px;
  line-height: 28px;
  margin: 0 0 12px;
  text-align: left;
  width: 100%;

  ${({ center }) => center
    ? css `
          text-align: center;
        `
    : null}
`;
const inputStyles = css `
  display: block;
  background: #ffffff;
  border: 1px solid #707070;
  ${fonts.DaxPro.Regular};
  font-size: 16px;
  height: 45px;
  line-height: 28px;
  margin: 0;
  padding: 0 8px;
  width: 100%;
`;
const Input = styled.input `
  ${inputStyles}
`;
const TextArea = styled.textarea `
  ${inputStyles}
`;
const Error = styled.span `
  display: block;
  color: #c70704;
  ${fonts.DaxPro.Regular};
  font-size: 14px;
  line-height: 20px;
  margin: 8px 0 0;
  padding: 0;
  text-align: ${({ center }) => (center ? 'center' : 'left')};
`;
const ForgottenPassword = styled.a `
  display: block;
  margin-top: 10px;
  text-align: right;
  text-decoration: none;

  small {
    font-size: 14px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const Submit = styled.button `
  display: block;
  border: 0;
  background: #6f9d20;
  color: #fff;
  ${fonts.DaxPro.Bold};
  font-size: 16px;
  height: 45px;
  line-height: 28px;
  margin: 0;
  padding: 0 8px;
  text-align: center;
  width: 100%;
`;
const Message = styled.p `
  color: #000000;
  ${fonts.DaxPro.Regular};
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  a {
    color: #6f9d20;
    text-decoration: underline;
  }
`;
export const LoginModalStyles = {
    CloseButton,
    CloseIcon,
    Container,
    Error,
    Field,
    Form,
    Inner,
    Input,
    Label,
    Message,
    ForgottenPassword,
    Submit,
    TextArea,
};
